import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'

export const Categoria = () => {
  return (
    <Flex gap={2}>
      {Array.from({ length: 8 }).map((_, index) => (
        <Flex flexDir="column" gap={1} key={index}>
          <Box w="full" maxW="120px" height="120px" borderRadius="md" bg="gray.200" flexDir={'column'} gap={5} />
          <Text fontSize="sm" fontWeight="bold">
            Categoria {index + 1}
          </Text>
          <Text fontSize="sm">Descrição da categoria {index + 1}</Text>
        </Flex>
      ))}
    </Flex>
  )
}
